"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Formats phone numbers for display.
 * @param phoneNumber - The number to format.
 */
function Format(phoneNumber) {
    let tempPhoneNumber = phoneNumber;
    // 10-digit format: (###) ###-####
    if (phoneNumber) {
        if (phoneNumber.length === 10) {
            tempPhoneNumber = '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6);
        }
    }
    return tempPhoneNumber;
}
exports.Format = Format;
/**
 * Formats phone numbers for a provided locale.
 * @param phoneNumber - The number to format.
 * @param locale - locale to format to
 * @param forOptInText - flag to let us know if it's for opt in text
 */
function FormatByLocale(phoneNumber, inpLocale, forOptInText) {
    let tempPhoneNumber = '';
    let optInFlag = false;
    let locale = inpLocale && inpLocale.length > 0 ? inpLocale : 'en-US';
    if (forOptInText !== null && forOptInText !== undefined) {
        optInFlag = forOptInText;
    }
    if (phoneNumber && phoneNumber !== '0') {
        if (locale.toUpperCase() !== 'EN-GB') {
            // Default / en-US / en-CA / fr-CA
            if (phoneNumber.length === 11) {
                if (!!optInFlag) {
                    tempPhoneNumber = `${phoneNumber.substring(1, 4)}-${phoneNumber.substring(4, 7)}`;
                    tempPhoneNumber = tempPhoneNumber + `-${phoneNumber.substring(7)}`.toString();
                }
                else {
                    tempPhoneNumber = `(${phoneNumber.substring(1, 4)}) ${phoneNumber.substring(4, 7)}`;
                    tempPhoneNumber = tempPhoneNumber + `-${phoneNumber.substring(7)}`.toString();
                }
            }
            else if (phoneNumber.length === 10) {
                if (!!optInFlag) {
                    tempPhoneNumber = `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}`;
                    tempPhoneNumber = tempPhoneNumber + `-${phoneNumber.substring(6)}`.toString();
                }
                else {
                    tempPhoneNumber = `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}`;
                    tempPhoneNumber = tempPhoneNumber + `-${phoneNumber.substring(6)}`.toString();
                }
            }
            else if (phoneNumber.length === 7) {
                tempPhoneNumber = `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3)}`.toString();
            }
            else {
                tempPhoneNumber = phoneNumber;
            }
        }
        else {
            // en-GB
            if (/^[0-9]{14}$/.test(phoneNumber)) {
                tempPhoneNumber = phoneNumber.substring(0, 2) + ' ' + phoneNumber.substring(2, 4) + ' ' + phoneNumber.substring(4);
            }
            else if (/^[0-9][0-9][\s][0-9]{12}$/.test(phoneNumber)) {
                tempPhoneNumber = phoneNumber.substring(0, 5) + ' ' + phoneNumber.substring(5);
            }
            else if (/^[0-9][0-9][0-9][0-9][\s][0-9]{8}$/.test(phoneNumber)) {
                tempPhoneNumber = phoneNumber.substring(0, 2) + ' ' + phoneNumber.substring(2);
            }
            else {
                tempPhoneNumber = phoneNumber;
            }
        }
    }
    return tempPhoneNumber;
}
exports.FormatByLocale = FormatByLocale;
//# sourceMappingURL=PhoneNumberFormat.js.map